export default {
	data() {
		return {
			loading: false,
		}
	},

	computed: {
		applicationLimit() {
			return this.$store.getters['shortlist-me/getApplicationLimit'];
		},

		appliedJobs() {
			return this.jobs.filter((job) => Boolean(job.internal_status));
		},

		availableJobs() {
			return this.jobs.filter((job) => !job.internal_status);
		},

		canApply() {
			return this.appliedJobs.length < this.applicationLimit;
		},

		jobs() {
			return this.$store.getters['shortlist-me/getJobs'];
		},
	},

	methods: {
		apply(job_id) {
			this.loading = true;

			this.$store.dispatch('shortlist-me/applyForJobInterview', job_id)
				.then(() => {
					this.$toast.success(this.$t('mock_interview_apply_success', {email: this.$auth.user.email}));
				})
				.catch(({ response }) => {
					const errorMessage = response?.status === 403
						? response?.data?.message || this.$t('oops_please_try_again')
						: this.$t('oops_please_try_again');

					this.$toast.danger(errorMessage);
				})
				.finally(() => {
					this.loading = false;
					this.$emit('close-modal');
				});
		},

		confirmApplication(job_id) {
			this.$modal.show({
				type: 'info',
				title: this.$t('mock_interviews_confirmation_title'),
				body: this.$t('mock_interviews_confirmation_text', [this.applicationLimit]),
				primary: {
					label: this.$t('confirm'),
					theme: 'indigo',
					action: () => this.apply(job_id),
				},
				secondary: {
					label: this.$t('cancel'),
					theme: 'white',
					action: () => ({}),
				},
			});
		},

		userHasAppliedToJob(job) {
			return Boolean(job.internal_status);
		},
	},
}
